import { Tooltip } from '@mui/material';
import { useEffect, useRef } from 'react';

export const AutoTooltip = ({
  open,
  onOpenChange,
  autoCloseMs = 5000,
  title,
  children,
}: {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  autoCloseMs?: number;
  title: React.ReactNode;
  children: React.ReactElement;
}) => {
  const timerRef = useRef<number | null>(null);

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const close = () => {
    clear();
    onOpenChange?.(false);
  };

  useEffect(() => {
    clear();
    if (open) timerRef.current = window.setTimeout(close, autoCloseMs);
    return clear;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, autoCloseMs]);

  return (
    <Tooltip
      open={open}
      arrow
      title={title}
      disableHoverListener
      disableInteractive={false}
      slotProps={{
        tooltip: {
          sx: {
            pointerEvents: 'auto',
            backgroundColor: 'var(--mui-palette-primary-dark)',
            border: '1px solid var(--mui-palette-divider)',
            color: 'var(--mui-palette-primary-main)',
          },
          onMouseEnter: clear,
          onMouseLeave: () => {
            clear();
            timerRef.current = window.setTimeout(close, autoCloseMs);
          },
        },
        arrow: {
          sx: {
            color: 'var(--mui-palette-divider)',
          },
        },
      }}
      onClose={close}
    >
      {children}
    </Tooltip>
  );
};
